import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import { Shimmer } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useEffect } from 'react';
import useResizeObserver from 'use-resize-observer'; // useResizeObserver is now available in usehooks-ts@2.13.0
import { FOOTPRINT_FOOTER_ID } from '../../constants';
import { useLayoutOptions } from '../layout-options-provider';
import FooterContent from './components/footer-content';
import MobileFooter from './components/mobile-footer';
type FootprintFooterProps = {
  hideOnDesktop?: boolean;
  config?: OnboardingSessionConfig;
  defaultOpen?: boolean;
};
const FootprintFooter = ({
  hideOnDesktop,
  config,
  defaultOpen
}: FootprintFooterProps) => {
  const {
    footer: {
      options,
      set: updateFooterOptions
    }
  } = useLayoutOptions();
  const {
    visible: footerVisible,
    position: footerPosition
  } = options;
  const {
    ref,
    height,
    width
  } = useResizeObserver({
    box: 'border-box'
  });

  // this width used on iframe still fits the footer items in a row
  const isSmallMobile = !!width && width < 470;
  useEffect(() => {
    if (footerVisible) {
      updateFooterOptions({
        height: height ?? 0
      });
    } else {
      updateFooterOptions({
        height: 0
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height]);
  if (!config) {
    return <Shimmer height="50px" width="100%" />;
  }

  // if we don't need to show footprint logo, the items fit well in the regular footer
  if (isSmallMobile && config.showFootprintLogo) {
    return <MobileFooter ref={ref} footerVisible={footerVisible} config={config} defaultOpen={defaultOpen} footerPosition={footerPosition} />;
  }
  return <div className={cx({
    'min-[900px]:hidden': hideOnDesktop,
    'sticky bottom-0 z-5': footerPosition === 'sticky',
    'relative z-1': footerPosition !== 'sticky'
  })}>
      <FooterContent id={FOOTPRINT_FOOTER_ID} ref={ref} config={config} hideSoc className={cx('h-10 justify-between border-t border-tertiary bg-secondary w-full [&>ul]:gap-3', {
      hidden: !footerVisible
    })} />
    </div>;
};
export default FootprintFooter;